import { render, staticRenderFns } from "./dosion-video.vue?vue&type=template&id=3f6761fb&"
import script from "./dosion-video.vue?vue&type=script&lang=js&"
export * from "./dosion-video.vue?vue&type=script&lang=js&"
import style0 from "./dosion-video.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports